import script from "./MapNewsListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MapNewsListCard.vue?vue&type=script&setup=true&lang=js"

import "./MapNewsListCard.vue?vue&type=style&index=0&id=50f3c937&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f3c937"]])

export default __exports__